// extracted by mini-css-extract-plugin
export default {"root":"gift_campaign_form_root__oqp1U","footer":"gift_campaign_form_footer__Ba4+o","saveButton":"gift_campaign_form_saveButton__puH2o"};